import { styled } from '@linaria/react';
import { StyledLandingSection } from './LandingSection';
export const StyledLogoCloud = /*#__PURE__*/styled("div")({
  name: "StyledLogoCloud",
  class: "s18upexp"
});
export const LandingLogoCloud = () => {
  return <StyledLandingSection className="logosCloud">
			<div className="content">
				<h1 className="blue">Trusted By Top Companies &amp; Creators</h1>
				<StyledLogoCloud>
					{
          /* <div>
          <div className="trustedByLogo">
          	<img src="/img/fundbmc-logo.png" alt="fundbmc.com" />
          </div>
          </div> */
        }
					<div>
						<div className="logoFig">
							<img src="/img/vidbase-studios-logo.svg" alt="vidbase.studio" width="312" height="130" />
						</div>
					</div>
					<div>
						<div className="logoFig">
							<img src="/img/vidbase-studios-logo.svg" alt="vidbase.studio" width="312" height="130" />
						</div>
					</div>
					<div>
						<div className="logoFig">
							<img src="/img/vidbase-studios-logo.svg" alt="vidbase.studio" width="312" height="130" />
						</div>
					</div>
					<div>
						<div className="logoFig">
							<img src="/img/vidbase-studios-logo.svg" alt="vidbase.studio" width="312" height="130" />
						</div>
					</div>
					<div>
						<div className="logoFig">
							<img src="/img/vidbase-studios-logo.svg" alt="vidbase.studio" width="312" height="130" />
						</div>
					</div>
					<div>
						<div className="logoFig">
							<img src="/img/vidbase-studios-logo.svg" alt="vidbase.studio" width="312" height="130" />
						</div>
					</div>
				</StyledLogoCloud>
			</div>
		</StyledLandingSection>;
};

require("./LandingLogoCloud.linaria.module.css!=!../../../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./LandingLogoCloud.tsx");